/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Tracking_NumberInputs */

const en_orders_tracking_number = /** @type {(inputs: Orders_Tracking_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking #`)
};

const es_orders_tracking_number = /** @type {(inputs: Orders_Tracking_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking #`)
};

/**
* | output |
* | --- |
* | "Tracking #" |
*
* @param {Orders_Tracking_NumberInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_tracking_number = /** @type {((inputs?: Orders_Tracking_NumberInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Tracking_NumberInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_tracking_number(inputs)
	return es_orders_tracking_number(inputs)
});